import angular from 'angular';
import { BucketService } from './buckets.service/buckets';
import { Pricing } from './service.tn.pricing';

export default angular
    .module('tn.pricing', ['tn.licenses'])
    // providers
    .service('tn.pricing.service', Pricing)
    .service('tnBuckets', BucketService).name;
